import { Component } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { LoadingIndicatorService } from '../../e-met/services/loading-indicator.service';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
    loadingStatus$ = this.service.loadingStatus$.pipe(
        filter(
            (ev) =>
                ev.reqId === 'approve' ||
                ev.reqId === 'name-initials-buyers' ||
                ev.reqId === 'name-initials-sellers'
        ),
        map((status) => status.loading)
    );
    constructor(private service: LoadingIndicatorService) {}
}
